import { useSelector } from 'react-redux';
import { PrimaryEntityItem } from '../../redux/localReports/localReports.proptype';
import { selectPrimaryEntitiesList } from '../../selectors';

export const usePrimaryEntitiesList = (): PrimaryEntityItem[] => {
  const primaryEntities = useSelector(selectPrimaryEntitiesList);

  return primaryEntities;
};
